import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchMonthSummary = async (formId: number) => {
	const response = await cmsClient.get<IMonthlyReport | null>(
		"/observations/reports/month-summary/",
		{
			params: {
				form: formId
			}
		}
	);

	return response.data;
};

const useMonthSummary = (formId: number) => {
	const query = useQuery(["month-summary", formId], () =>
		fetchMonthSummary(formId)
	);

	return query;
};

export default useMonthSummary;
